/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import CourseViewer from "../components/dashboard/CourseViewer";
import api from "../services/api";
import { useSession } from "../context/AuthContext";

export default function CourseDetail() {
  const { id } = useParams<{ id: string }>();
  const { data: session }: any = useSession();
  const [courseData, setCourseData] = useState<any>(null);
  const [activeVideoUrl, setActiveVideoUrl] = useState<string>("");
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchCourseDetail = async () => {
      try {
        const userId = session?.user?.id || '';
        const res = await api.get(`/courses/${id}?userId=${userId}`);
        const course = res.data;
        
        if (course && course.id) {
          setActiveVideoUrl(course.videoLink || "");
          setCourseData({
            courseId: course.id,
            title: course.title,
            description: course.description,
            highlightsLink: course.highlightsLink || "",
            tasks: course.tasks?.map((t: any) => ({
              ...t,
              topic: t.topic?.name || "General",
              status: "pending" as const
            })) || [],
            what_youll_learn: course.what_youll_learn || [],
            category: course.category || null,
            courseTopics: course.topics?.map((t: any) => t.name) || [],
            learning_order: course.learning_order,
            estimated_duration_minutes: course.estimated_duration_minutes,
            difficulty_level: course.difficulty_level,
            feedback_links: course.feedback_links || [],
            isCompleted: course.isCompleted || false,
            createdAt: course.createdAt,
            coachName: course.createdBy?.name || course.created_by?.name,
            is_locked: course.is_locked,
            upsell_offer: course.upsell_offer
          });
        } else {
          setError("Failed to locate course details.");
        }
      } catch (err: any) {
        console.error("Failed to load course details:", err);
        setError("Error loading course details from the API server.");
      }
    };
    if (id) fetchCourseDetail();
  }, [id]);

  if (error) {
    return (
      <div className="bg-red-500/10 border border-red-500/20 p-8 rounded-3xl backdrop-blur-md shadow-sm">
        <h1 className="text-2xl font-black text-red-500">Error</h1>
        <p className="text-sm text-red-400 mt-2">{error}</p>
      </div>
    );
  }

  if (!courseData) {
    return (
      <div className="min-h-[400px] flex flex-col items-center justify-center text-on-surface gap-4">
        <span className="material-symbols-outlined text-6xl opacity-30 animate-spin">progress_activity</span>
        <p className="text-xs font-black uppercase tracking-[0.2em] opacity-80">Initializing Focus Workspace...</p>
      </div>
    );
  }

  return (
    <div className="w-full">
      <CourseViewer {...courseData} videoUrl={activeVideoUrl} />
    </div>
  );
}
